import React, { useState, useContext } from 'react';
import { Form, Input, Button, Card, message, Tabs } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const Auth = () => {
  const [form] = Form.useForm();
  const [registerForm] = Form.useForm();
  const { login, register } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  const from = location.state?.from?.pathname || "/";

  const handleLogin = async (values) => {
    const success = await login(values.username, values.password);
    if (success) {
      message.success('登录成功');
      navigate(from, { replace: true });
    } else {
      message.error('用户名或密码错误');
    }
  };

  const handleRegister = async (values) => {
    const success = await register(values.username, values.email, values.password);
    if (success) {
      message.success('注册成功，请登录');
      // 使用更安全的方式切换到登录标签页
      setTimeout(() => {
        const loginTab = document.querySelector('.ant-tabs-tab:nth-child(1)');
        if (loginTab) {
          loginTab.click();
        }
      }, 100);
    } else {
      message.error('注册失败，用户名可能已存在');
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: 'calc(100vh - 64px - 106px)',
      background: '#f5f5f5',
      padding: '20px'
    }}>
      <Card style={{ width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2>Qmau的博客</h2>
          <p>欢迎来到我的博客系统</p>
        </div>
        
        <Tabs defaultActiveKey="login" centered>
          <Tabs.TabPane tab="登录" key="login">
            <Form
              form={form}
              name="login"
              initialValues={{ remember: true }}
              onFinish={handleLogin}
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名!' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="用户名" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="密码" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  登录
                </Button>
              </Form.Item>
            </Form>
          </Tabs.TabPane>
          
          <Tabs.TabPane tab="注册" key="register">
            <Form
              form={registerForm}
              name="register"
              onFinish={handleRegister}
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名!' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="用户名" />
              </Form.Item>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: '请输入邮箱!' },
                  { type: 'email', message: '请输入正确的邮箱格式!' }
                ]}
              >
                <Input prefix={<MailOutlined />} placeholder="邮箱" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: '请输入密码!' },
                  { min: 6, message: '密码至少6位' }
                ]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="密码" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  注册
                </Button>
              </Form.Item>
            </Form>
          </Tabs.TabPane>
        </Tabs>
        
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <p>提示: 使用qmau账号才可使用所有功能，密码为123456</p>
        </div>
      </Card>
    </div>
  );
};

export default Auth;